// extracted by mini-css-extract-plugin
export default {"Quote":"style_Quote__rG3f+","gap":"style_gap__lcbcd","content":"style_content__xRfcB","hero":"style_hero__uswRT"};